'use client';

import React from 'react';
import ContactForm from './ContactForm';
import Link from 'next/link';
import { useSettings } from '@/hooks/useSettings';

const Contact = () => {
  const { generalSettings } = useSettings();
  return (
    <>
      {/* ================> Page header start here <================== */}
      <section className="page-header">
        <div className="container">
          <div className="page-header__content">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item ">
                  <Link href="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Contact Us
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      {/* ================> Page header end here <================== */}
      {/* ===============>> Contact section start here <<================= */}
      <ContactForm data={{ data: generalSettings }} />
      {/* ===============>> Contact section end here <<================= */}
    </>
  );
};

export default Contact;
